import { extendTheme } from '@chakra-ui/react'
import { Button } from './components/Button'
import { Text } from './components/Text'
import { Input } from './components/Input'
import { Radio } from './components/Radio'
import { Textarea } from './components/Textarea'
import { Checkbox } from './components/Checkbox'
import { Switch } from './components/Switch'
import { NumberInput } from './components/NumberInput'
import { createBreakpoints } from '@chakra-ui/theme-tools'
import { HomeIcon } from './icons/icons.jsx'

import './index.css'

const breakpoints = createBreakpoints({
  desktop: '900px',
})

export const theme = extendTheme({
  colors: {
    text: {
      primary: 'var(--chakra-colors-text)',
    },
    brand: {
      white: '#FFFFFF',
      error: '#E53E3E',
      black: '#000000',

      // colors receiving from BE will be modified
      primary: 'var(--chakra-colors-primary)',
      secondary: 'var(--chakra-colors-secondary)',
      accent: 'var(--chakra-colors-accent)',
      header: 'var(--chakra-colors-header)',
      card: 'var(--chakra-colors-card)',
      'card-font': 'var(--chakra-colors-card-font)',
      background: 'var(--chakra-colors-background)',
      contrast: 'var(--chakra-colors-header-font)',
      menuItem: 'var(--chakra-colors-menu-item)',
      // custom colors
      borderColor: 'var(--chakra-borders-button)',
    },
    button: {
      primary: 'var(--chakra-colors-accent)',
      primaryHover: 'var(--chakra-buttons-primary-hover)',
      primaryFocus: 'var(--chakra-buttons-primary-focus)',

      outline: 'brand.white',
      outlineHover: 'var(--chakra-buttons-outline-hover)',
      outlineFocus: 'var(--chakra-buttons-outline-focus)',
    },
    icon: {
      container: 'var(--chakra-colors-primary)',
    },
    input: {
      background: 'brand.white',
      border: 'var(--chakra-input-border)',
      borderHover: 'var(--chakra-input-border-hover)',
      placeholder: 'var(--chakra-colors-placeholder)',
      text: 'var(--chakra-colors-text)',
    },
  },
  radii: {
    base: '9999px',
    md: '6px',
    lg: '15px',
  },
  shadows: {
    outline: 'none',
  },
  fontSizes: {
    xs: 'var(--chakra-fontSizes-xs)',
    sm: 'var(--chakra-fontSizes-sm)',
    md: 'var(--chakra-fontSizes-md)',
    lg: 'var(--chakra-fontSizes-lg)',
    xl: 'var(--chakra-fontSizes-xl)',
    '2xl': 'var(--chakra-fontSizes-2xl)',
  },
  sizes: {
    '3xs': '160px',
  },
  components: {
    Button,
    Text,
    Input,
    Radio,
    Textarea,
    Checkbox,
    Switch,
    NumberInput,
  },
  breakpoints,
  styles: {
    global: {
      body: {
        minHeight: '100vh',
        backgroundColor: 'var(--chakra-colors-background)',
      },
    },
  },
  icons: {
    HomeIcon,
  },
})
